export default "__VITE_ASSET__DXF6DDie__"